// extracted by mini-css-extract-plugin
module.exports = {"root":"EmployeeDetailView_root_2jBEa","inner":"EmployeeDetailView_inner_POwjF"};